<template>
  <drag-drawer v-model="showDrawer"
               :width.sync="width"
               :min-width="minWidth"
               :inner="true"
               :transfer="false"
               :placement="placementComputed"
               :draggable="true"
               @on-resize="handleResize"
               @on-close="handleClose"
               :scrollable="true">
    <div slot="header">
      <label>{{title}}</label>
    </div>
    <!--top-->
    <div>
      <el-input placeholder="名词名称" v-model="searchValue" class="input-with-select">
        <el-button type="primary" slot="append" icon="el-icon-search" @click="searchData"></el-button>
      </el-input>
      <span style="float:right;">
        <el-button type="primary" @click="addNoun('1')">新建标准名词&nbsp;
            <Poptip
              placement="top"
              width="300"
              word-wrap
              transfer
              trigger="hover"
              content="新建标准名词：标准名词是用创建多个同义词的方法来增强名词识别能力的类型。">
            <!--<i class="el-icon-info"></i>--><img :src="questionMark" class="tip-img"/>
            </Poptip>
        </el-button>

        <el-button type="primary" slot="reference" @click="addNoun('0')">新建正则名词&nbsp;
          <Poptip
            placement="top"
            width="300"
            word-wrap
            trigger="hover"
            transfer
            content="新建正则名词：正则名词是用创建一个有正则格式规范的方法来增强名词识别能力的类型。">
            <img :src="questionMark" class="tip-img"/>
          </Poptip>
        </el-button>
      </span>
    </div>
    <!--table-->
    <div>
      <el-table
        :data="nounData"
        style="width: 100%"
      >
        <el-table-column
          property="name"
          label="名词名称">
        </el-table-column>
        <el-table-column
          label="名词成员及其同义词">
          <template slot-scope="scope">
            <p v-for="(option,index) in scope.row.showData" :key="index">{{option}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <!--弹窗-->
    <NonuDialog :nounId="nounId" :show="showDialog" :isEdit="isEdit" :type="nounType" :flowId="flowId" @close="changeShow"></NonuDialog>
  </drag-drawer>
</template>

<script>
    import DragDrawer from "./dragDrawer/drag-drawer";
    import NonuDialog from "./NonuDialog";

    export default {
      name: "NonuDrawer",
      components: {NonuDialog, DragDrawer},
      props: ['noun', 'flowId'],
      data() {
        return {
          width: 600,
          minWidth: 600,
          title:'名词',
          placement: 'right',
          showDrawer: false,
          searchValue: '',
          nounData:[{name:'test',regex:'.{0}[1-2]'}],
          showDialog:false,
          nounId:'',
          isEdit:false,
          nounType:'1',
          questionMark:require('../../../assets/image/homeAsk.png'),
        }
      },
      methods: {
        initData(flowId) {
          let that = this
          let param = {rwId:flowId,name:this.searchValue}
          this.$http.post('/AI/FlowDetail/queryNouns',param).then(res=>{
            let response = res.data
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
            let datas = response.obj
            if (datas.length > 0) {
              datas.forEach(noun=>{
                let type = noun.type
                let arr = []
                if (type === 0) {
                  arr.push(noun.expression)
                }else if (type === 1) {
                  if (noun.thesauses.length > 0) {
                    noun.thesauses.forEach(n => {
                      arr.push(n.member + '-----'+n.thesaurus)
                    });
                  }
                }
                noun.showData = arr
              })
            }
            this.nounData = datas;
          })
        },
        searchData() {
          this.initData(this.flowId)
        },
        handleResize(event) {
          const {atMin} = event
          console.log(atMin)
        },
        handleClose(val) {
          this.$emit('closeDrawer', true)
        },
        changeShow(val) {
          this.showDialog = val
          if (!val) {
            this.initData(this.flowId)
          }
        },
        handleEdit(index, row) {
          this.isEdit = true
          this.nounType = row.type
          this.nounId = row.id
          this.showDialog = true
        },
        addNoun(type) {
          this.nounType = type
          this.isEdit = false
          this.nounId = ''
          this.showDialog = true
        },
        handleDelete(index, row) {
          let param = {
            rwId:this.flowId,
            nounId: row.id,
            menuId:'a_2-8',
            journalType:'AI机器人管理=>流程绘制=>删除专有名词'
          }
          let that = this
          this.$Modal.confirm({
            title:'提示',
            content:'是否确认删除',
            onOk:()=>{
              that.$http.post('/AI/FlowDetail/deleteNoun',param).then(res=>{
                let response = res.data
                if (response.flag !== '666') {
                  that.$alert(response.msg,'提示',{
                    confirmButtonText: '确定'
                  })
                  return false
                }
                that.$Message.info('删除成功')
                that.initData(that.flowId)
              })
            }
          })
        }
      },
      computed: {
        placementComputed() {
          return this.placement ? 'left' : 'right'
        }
      },
      watch:{
        noun:{
          deep:true,
          immediate:true,
          handler(val) {
            if (val) {
              this.showDrawer = true
              this.initData(this.flowId)
            }
          }
        }
      }
    }
</script>

<style scoped lang="css">
.tip-img {
  max-width: 13px;
  max-height: 13px;
  padding-left: 1px;
  filter: grayscale(50%);
  -webkit-filter: grayscale(50%);
  -moz-filter: grayscale(50%);
  -ms-filter: grayscale(50%);
  -o-filter: grayscale(50%);
}
</style>



// WEBPACK FOOTER //
// src/components/flow/components/NonuDrawer.vue